<template>
  <article>
    <object ref="object" type="application/pdf" data="" class="preview">
      <embed
        ref="embed"
        type="application/pdf"
        src=""
        class="preview"
        frameborder="0"
      /><embed />
    </object>
  </article>
</template>

<script>
import invoiceMake from '../utils/invoiceMake';

// TODO implement PDFObject to cover displaying to all browser (are putting a link)

function debounce(callback, wait, immediate = false) {
  let timeout = null;

  return function() {
    const callNow = immediate && !timeout;
    const next = () => callback.apply(this, arguments);

    clearTimeout(timeout);
    timeout = setTimeout(next, wait);

    if (callNow) {
      next();
    }
  };
}

let renderFnSave = null;

import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'InvoicePreview',
  props: {
    invoice: { type: Object, default: () => ({}) }
  },
  computed: {
    ...mapGetters('auth', ['uid'])
  },
  watch: {
    invoice: {
      deep: true,
      handler(val) {
        // this.render();
        renderFnSave();
      }
    }
  },
  mounted() {
    renderFnSave = debounce(() => this.render(), 1000, true);
    this.render();
  },
  methods: {
    async render() {
      const pdf = await invoiceMake(
        this.invoice,
        this,
        this.$i18n && this.$i18n.current,
        this.uid
      );
      pdf.getDataUrl(dataUrl => {
        this.$refs.object.data = dataUrl;
        this.$refs.embed.src = dataUrl;
        // embed.src = dataUrl;
        // PDFObject.embed(dataUrl, this.$refs.preview);
      });
    }
  }
};
</script>

<style scoped>
.preview {
  width: 100%;
  height: 90vh;
}
</style>
